module.exports = __webpack_public_path__ + "media/images/Groupe 162-93f1e6d6ff9a88b9f8a46f178ef52089.svg";